import React from "react";

export interface AIFlightAgentIconProps {
  fill?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

const AIFlightAgentIcon: React.FC<AIFlightAgentIconProps> = ({
  fill = "#E4E4E4",
  width = 20,
  height = 18,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 18"
      fill="none"
      className={className}
    >
      <path
        d="M8.22656 1.51172L8.71875 0.175781C8.75391 0.0703125 8.85938 0 9 0C9.10547 0 9.21094 0.0703125 9.24609 0.175781L9.73828 1.51172L11.0742 2.00391C11.1797 2.03906 11.25 2.14453 11.25 2.25C11.25 2.39062 11.1797 2.49609 11.0742 2.53125L9.73828 3.02344L9.24609 4.32422C9.21094 4.42969 9.10547 4.5 9 4.5C8.85938 4.5 8.75391 4.42969 8.71875 4.32422L8.22656 3.02344L6.92578 2.53125C6.82031 2.49609 6.75 2.39062 6.75 2.25C6.75 2.14453 6.82031 2.03906 6.92578 2.00391L8.22656 1.51172ZM16.207 1.6875L12.3398 5.55469L13.5703 6.78516L17.4375 2.91797L16.207 1.6875ZM2.8125 15.1172L4.00781 16.3125L12.375 7.98047L11.1445 6.75L2.8125 15.1172ZM15.0117 0.527344C15.6797 -0.140625 16.7344 -0.140625 17.4023 0.527344L18.5977 1.72266C19.2656 2.39062 19.2656 3.44531 18.5977 4.11328L5.20312 17.5078C4.53516 18.1758 3.48047 18.1758 2.8125 17.5078L1.61719 16.3125C0.949219 15.6445 0.949219 14.5898 1.61719 13.9219L15.0117 0.527344ZM0.246094 4.14844L2.25 3.375L2.98828 1.40625C3.02344 1.23047 3.19922 1.125 3.375 1.125C3.51562 1.125 3.69141 1.23047 3.72656 1.40625L4.5 3.375L6.46875 4.14844C6.64453 4.18359 6.75 4.35938 6.75 4.5C6.75 4.67578 6.64453 4.85156 6.46875 4.88672L4.5 5.625L3.72656 7.62891C3.69141 7.76953 3.51562 7.875 3.375 7.875C3.19922 7.875 3.02344 7.76953 2.98828 7.62891L2.25 5.625L0.246094 4.88672C0.105469 4.85156 0 4.67578 0 4.5C0 4.35938 0.105469 4.18359 0.246094 4.14844ZM12.6211 13.1484L14.625 12.375L15.3633 10.4062C15.3984 10.2305 15.5742 10.125 15.75 10.125C15.8906 10.125 16.0664 10.2305 16.1016 10.4062L16.875 12.375L18.8438 13.1484C19.0195 13.1836 19.125 13.3594 19.125 13.5C19.125 13.6758 19.0195 13.8516 18.8438 13.8867L16.875 14.625L16.1016 16.6289C16.0664 16.7695 15.8906 16.875 15.75 16.875C15.5742 16.875 15.3984 16.7695 15.3633 16.6289L14.625 14.625L12.6211 13.8867C12.4805 13.8516 12.375 13.6758 12.375 13.5C12.375 13.3594 12.4805 13.1836 12.6211 13.1484Z"
        fill={fill}
      />
    </svg>
  );
};

export default AIFlightAgentIcon;
